import React from "react"

import { noop } from "shared/lib/noop"
import { Breadcrumb } from "shared/ui/breadcrumb/Breadcrumb"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { BuildingReferencePageView } from "./BuildingReferencePageView"

export const LoadingBuildingReferencePage = React.memo(() => (
  <BuildingReferencePageView
    isLoading
    breadcrumbSlot={<Breadcrumb isLoading breadcrumbItems={null} />}
    images={[
      {
        content: (
          <Skeleton containerClassName="building-reference-image-carousel__loading-image" />
        ),
        key: "loading image",
        title: "loading image"
      }
    ]}
    titleSlot={<Skeleton className="h2 w-50" />}
    installationReferences={[]}
    productFilterOptions={[]}
    activeProductFilters={[]}
    onActiveProductFiltersChange={noop}
    generalInfoViewModel={{
      copyToClipboard: noop
    }}
  />
))
